export default __webpack_public_path__ + "static/four-b098300a39038e94b9ad39480992fab6.png";